import $ from 'jquery';

const semantics = {
    'wrapClass': 'text-page-partners-v1',
};

$(function() {
    // let textPageDeliveryV1 = new TextPagePartnersV1();

    let $body = $('body');

	if (!$('.text-page-partners-v1').length) return false;

	$body.on('click', '.text-page-partners-v1-types__button_type', function() {
		let type = $(this).data('type');

		$('.text-page-partners-v1-types__button_type').removeClass('_active').addClass('_muted');
		$(this).removeClass('_muted').addClass('_active');

		$('.text-page-partners-v1-types__image, .text-page-partners-v1-types__title').removeClass('_active');

		$('.text-page-partners-v1-types__image_' + type).addClass('_active');

		$('.js-partners-types__list').removeClass('_active');
		$('.js-partners-types__list_' + type).addClass('_active');

		$('.text-page-partners-v1-types__button_success').data('type', $(this).data('value'));

		showPartnersTypeList($('.js-partners-types__list_' + type));
	});

	$body.on('click', '.js-partners-popup-button', function() {
		let type = $(this).data('type');

		const config = initPopup.prototype.getConfig('.js-partners-popup', {
            callbacks: {
                open() {
                	$('.js-partners-form')[0].reset();

                    if (type) {
                    	$('.js-partners-popup').find('.js-partners-select-type').val(type);
                    }

                    updatePopupList();
                }
            },
        });
       $.magnificPopup.open(config);
	});

	$body.on('change', '.js-partners-select-type', function() {
		updatePopupList();
	});

	$body.on('submit', '.js-partners-form', function(e) {
		e.preventDefault();

		let $form = $(this)
			, emptyCount = 0;

		$form.find('[aria-required="true"]').each(function() {
			if (!$(this).val()) {
				emptyCount++;
			}
		});

		if (emptyCount) {
			$form.yiiActiveForm('validate', true);
			return false;
		}

		$.post($form.action, $form.serializeArray(), function (res) {

			if (res.success) {
				const successPopup = $form.closest('.popup').find('.js-success-popup');
				$.magnificPopup.open(initPopup.prototype.getConfig(successPopup));
			} else {
				const failPopup = $form.closest('.popup').find('.js-error-popup');
				$.magnificPopup.open(initPopup.prototype.getConfig(failPopup));
			}
        });
	});

	function showPartnersTypeList($list) {
		$list.find('li').each((i, el) => {
			setTimeout(() => {$(el).addClass('_active')}, 500 * i);
		});

		setTimeout(() => {$('.text-page-partners-v1-types__button_success').addClass('_show')}, 500 * $list.find('li').length);
	}

	function updatePopupList() {
		let type = $('.js-partners-select-type').val().replace(/\s/g, '');

		$('.js-partners-popup__items').hide();
		$('.js-partners-popup__items_' + type).show();
	}
    
});

class TextPagePartnersV1
{
    constructor() {
    }

}